// extracted by mini-css-extract-plugin
export var container = "_fh-0";
export var content = "_fh-3";
export var customerTitle = "_fh-4";
export var empty = "_fh-5";
export var gray = "_fh-6";
export var header = "_fh-7";
export var info = "_fh-8";
export var loading = "_fh-2";
export var loadingCard = "_fh-9";
export var oneLine = "_fh-a";
export var personName = "_fh-e";
export var pillContainer = "_fh-b";
export var selected = "_fh-1";
export var text = "_fh-c";
export var twoLines = "_fh-d";
export var unread = "_fh-f";
export var unreadIndicator = "_fh-g";